// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"8d7d0797","757":"cbc1eb72"}[chunkId] + ".chunk.css";
};